export default __webpack_public_path__ + "f5ca9f4a346f19b1b3adadbdc4424500.svg";